<template>
  <CustomTooltip
    :text="tooltip"
    disable-closing-trigger
  >
    <MessageActionButton
      @click="copy()"
    >
      <i
        v-if="copied"
        class="tw:i-fas-check"
      />
      <i
        v-else
        class="tw:i-fas-copy"
      />
    </MessageActionButton>
  </CustomTooltip>
</template>

<script setup>
import { useClipboard } from '@vueuse/core'
import { computed } from 'vue'
import MessageActionButton from '@/components/common/message/message-action-button.vue'
import CustomTooltip from '@/components/custom-tooltip.vue'

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
})

const source = computed(() => props.message)
const { copy, copied } = useClipboard({
  source,
})

const tooltip = computed(() => copied.value ? 'Copied' : 'Click to copy')
</script>
